import { gql } from "@apollo/client"

export const SEARCH_TRANSACTIONS = gql`
    query searchTransactions(
        $searchParam: String
        $currentPage: Int!
        $pageSize: Int!
        $sort: TransactionsSortFields
    ) {
        searchTransactions(
            searchTransactionsInput: {
                searchParam: $searchParam
                currentPage: $currentPage
                pageSize: $pageSize
                sort: $sort
            }
        ) {
            transactionGroups {
                transactions {
                    id
                    referenceId
                    action
                    mode
                    metadata
                    user {
                        id
                        email
                    }
                    createdAt
                    prompt {
                        id
                    }
                }
            }
            totalPages
        }
    }
`
